package one.healthium.base.utils

import loco.GENERAL_LITRES
import loco.GENERAL_OZ
import one.healthium.loco.LString
import one.healthium.loco.asLString

fun Boolean.toVolumeUnit(): LString = if (this) {
    loco.Res.string.GENERAL_LITRES.asLString()
} else {
    loco.Res.string.GENERAL_OZ.asLString()
}